export class PermissionDto {

  constructor(
    public id: number,
  ) {}
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dto/permission.dto.ts